'use client'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { unEscape } from '@/shared/lib/utils/string/un-escape'
import { Col, Row } from '@/shared/ui'

import cl from '../../ui/product-page-header/product-page-header.module.scss'

export const DiscountProductHeader = (): JSX.Element => {
	const { product } = useProduct()

	return (
		<section className={cl.productTop}>
			<div className={cl.productTopServiceRow}>
				<Row>
					<Col xl={24} lg={24} md={24} xs={24}>
						<h1 id="productTitle" className={cl.productTopTitle}>
							{unEscape(product.TITLE)}
						</h1>
					</Col>
				</Row>
			</div>
		</section>
	)
}
